<template>
  <VContainer fluid class="ma-0 pa-0">
    <!-- DESKTOP -->
    <div class="d-none d-lg-block ma-0 pa-0">
      <VRow class="ma-0 pa-0">
        <VCol cols="7" class="semi-circle">
          <VRow class="ma-8 px-12">
            <VCol cols="12">
              <VCardTitle class="text-h2 text-white font-weight-bold">
                {{ $t('CONTACTS.SPEAK') }}
              </VCardTitle>
              <VCardTitle
                class="text-h4 text-left text-white font-weight-bold"
                style="white-space:pre-line;"
              >
                {{ $t('CONTACTS.SCHEDULE') }}
              </VCardTitle>
            </VCol>

            <VCol cols="12">
              <VCol cols="10">
                <Form :validation-schema="schema" @submit="enviarContacto" v-slot="{ meta }">
                  <fieldset :disabled="loading">
                    <VCard :class="{ shake: animated }">
                      <VCardTitle class="bg-primary">
                        <!-- título opcional -->
                      </VCardTitle>

                      <VCardText>
                        <VRow class="mt-4">
                          <VCol cols="12" md="12">
                            <Field name="name" v-slot="{ field, errorMessage }">
                              <VTextField
                                class="font-weight-bold"
                                v-bind="field"
                                v-model="fields.name"
                                :label="$t('CONTACTS.NAME')"
                                :error-messages="errorMessage"
                                variant="outlined"
                              />
                            </Field>
                          </VCol>

                          <VCol cols="12">
                            <Field name="email" v-slot="{ field, errorMessage }">
                              <VTextField
                                class="font-weight-bold"
                                v-bind="field"
                                v-model="fields.email"
                                label="Email"
                                :error-messages="errorMessage"
                                variant="outlined"
                              />
                            </Field>
                          </VCol>

                          <VCol cols="12" md="6">
                            <VTextField
                              class="font-weight-bold"
                              v-model="fields.company"
                              :label="$t('CONTACTS.EMPRESA')"
                              variant="outlined"
                            />
                          </VCol>

                          <VCol cols="12" md="6">
                            <Field name="numero" v-slot="{ field, errorMessage }">
                              <VTextField
                                class="font-weight-bold"
                                v-bind="field"
                                v-model="fields.numero"
                                :label="$t('CONTACTS.NUMERO')"
                                :error-messages="errorMessage"
                                variant="outlined"
                              />
                            </Field>
                          </VCol>

                          <VCol cols="12" md="6">
                            <VAutocomplete
                              class="font-weight-bold"
                              :items="countries"
                              item-title="nome"
                              item-value="nome"
                              v-model="fields.country"
                              :label="$t('CONTACTS.PAIS')"
                              variant="outlined"
                            />
                          </VCol>

                          <VCol cols="12" md="6">
                            <VAutocomplete
                              class="font-weight-bold"
                              :items="size_company[$i18n.locale]"
                              v-model="fields.size"
                              :label="$t('CONTACTS.SIZE')"
                              variant="outlined"
                            />
                          </VCol>

                          <VCol cols="12">
                            <VTextarea
                              class="font-weight-bold"
                              v-model="fields.description"
                              :label="$t('CONTACTS.DESCRIPTION')"
                              rows="2"
                              variant="outlined"
                            />
                          </VCol>
                        </VRow>

                        <!-- reCAPTCHA + Honeypot/startedAt -->
                        <div class="mt-4">
                          <div ref="rcDesktop"></div>
                          <input type="hidden" v-model="hp" name="website_hp" />
                          <input type="hidden" :value="startedAt" name="started_at" />
                        </div>
                      </VCardText>

                      <VCardActions>
                        <VRow align="center" justify="space-around">
                          <VCol align="center" justify="space-around">
                            <VBtn
                              :disabled="!meta.valid"
                              :color="(!meta.valid) ? '' : 'warning'"
                              class="mr-5 ml-5 font-weight-bold"
                              type="submit"
                              variant="flat"
                            >
                              <span v-if="meta.valid" style="color: white">{{ $t('CONTACTS.SEND') }}</span>
                              <span v-else>{{ $t('CONTACTS.SEND') }}</span>
                            </VBtn>
                          </VCol>
                        </VRow>
                      </VCardActions>
                    </VCard>
                  </fieldset>
                </Form>
              </VCol>
            </VCol>

            <VCol cols="12" md="10">
              <VContainer class="d-flex justify-center text-white" style="white-space: pre-line;" fluid>
                <table>
                  <thead>
                    <tr>
                      <td colspan="2" class="text-center">
                        <div class="text-h6 font-weight-medium">
                          {{ $t('PRE_FOOTER.contacts') }}
                        </div>
                      </td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class="text-h6 font-weight-light">
                      <td><VIcon class="text-white">mdi-email</VIcon></td>
                      <td>info@reportlake.com</td>
                    </tr>
                    <tr class="text-h6 font-weight-light">
                      <td><VIcon class="text-white">mdi-clock</VIcon></td>
                      <td>{{ $t('PRE_FOOTER.work_week') }} - 9h {{ $t('PRE_FOOTER.to') }} 18h</td>
                    </tr>
                    <tr class="text-h6 font-weight-light">
                      <td><VIcon class="text-white">mdi-phone</VIcon></td>
                      <td>+351 220 280 430</td>
                    </tr>
                  </tbody>
                </table>
              </VContainer>
            </VCol>
          </VRow>
        </VCol>

        <VCol cols="5">
          <VRow class="ma-8 px-12">
            <VCol cols="12">
              <div class="circleContacts text-white" style="margin: auto;">
                <div class="circleContacts-txt">Envie-nos um email<br/> que responderemos<br/> o mais brevemente<br/> possível</div>
                <div class="circleContacts-img">@</div>
              </div>
            </VCol>

            <VCol cols="12">
              <div style="margin-right: 50%">
                <div class="second-circle" style="margin: auto;">
                  <div class="second-circle-txt text-white">Agende uma<br/>chamada connosco<br/>para tirar todas as<br/>suas dúvidas!</div>
                  <div class="second-circle-img"><i class="mdi mdi-phone"></i></div>
                </div>
              </div>
            </VCol>

            <VCol cols="12" class="mt-n4">
              <div style="margin-right: 75%;">
                <div class="small-circle" style="margin: auto;"></div>
              </div>
            </VCol>

            <VCol cols="12" class="mt-n4">
              <div style="margin-right: 60%;">
                <div class="xsmall-circle" style="margin: auto;"></div>
              </div>
            </VCol>

            <VCol cols="12" v-if="false">
              <div style="margin-left: 30%; margin-top: -10%">
                <VBtn size="x-large" class="warning" style="width: 300px;" @click="emailSender()">
                  {{ $t('CONTACTS.SEND_EMAIL') }}
                </VBtn>
              </div>
            </VCol>

            <VCol cols="12">
              <div style="margin-left: 30%;">
                <VBtn size="x-large" color="warning" style="width: 320px;" @click="clickHandler()">
                  <span style="color: white;">{{ $t('CONTACTS.SEND_MESSAGE') }}</span>
                </VBtn>
              </div>
            </VCol>
          </VRow>
        </VCol>
      </VRow>
    </div>

    <!-- MOBILE -->
    <div class="d-md-none">
      <VRow class="black-blue">
        <div class="semi-circle-mobile"></div>

        <VCol cols="12" style="z-index: 2;">
          <VCardTitle class="text-h5 text-white font-weight-black">
            {{ $t('CONTACTS.SPEAK') }}
          </VCardTitle>
        </VCol>

        <VCol cols="12" class="mt-n12" style="z-index: 2;">
          <VCardTitle class="text-h6 text-left text-white font-weight-medium">
            {{ $t('CONTACTS.SCHEDULE') }}
          </VCardTitle>
        </VCol>

        <VCol cols="12" style="z-index: 2;">
          <Form :validation-schema="schema" @submit="enviarContacto" v-slot="{ meta }">
            <fieldset :disabled="loading">
              <VCard :class="{ shake: animated }">
                <VCardTitle class="yellow-back">
                  <span class="text-white text-subtitle-1 font-weight-bold">
                    <VIcon size="small" class="text-white mr-2">mdi-comment</VIcon>{{ $t('CONTACTS.NEW_MESSAGE') }}
                  </span>
                </VCardTitle>

                <VCardText>
                  <VRow class="mt-4">
                    <VCol cols="12" md="12">
                      <Field name="name" v-slot="{ field, errorMessage }">
                        <VTextField
                          class="font-weight-bold"
                          v-bind="field"
                          v-model="fields.name"
                          :label="$t('CONTACTS.NAME')"
                          :error-messages="errorMessage"
                          variant="outlined"
                        />
                      </Field>
                    </VCol>

                    <VCol cols="12">
                      <Field name="email" v-slot="{ field, errorMessage }">
                        <VTextField
                          class="font-weight-bold"
                          v-bind="field"
                          v-model="fields.email"
                          label="Email"
                          :error-messages="errorMessage"
                          variant="outlined"
                        />
                      </Field>
                    </VCol>

                    <VCol cols="12" md="6">
                      <VTextField
                        class="font-weight-bold"
                        v-model="fields.company"
                        :label="$t('CONTACTS.EMPRESA')"
                        variant="outlined"
                      />
                    </VCol>

                    <VCol cols="12" md="6">
                      <Field name="numero" v-slot="{ field, errorMessage }">
                        <VTextField
                          class="font-weight-bold"
                          v-bind="field"
                          v-model="fields.numero"
                          :label="$t('CONTACTS.NUMERO')"
                          :error-messages="errorMessage"
                          variant="outlined"
                        />
                      </Field>
                    </VCol>

                    <VCol cols="12" md="6">
                      <VAutocomplete
                        class="font-weight-bold"
                        :items="countries"
                        item-title="nome"
                        item-value="nome"
                        v-model="fields.country"
                        :label="$t('CONTACTS.PAIS')"
                        variant="outlined"
                      />
                    </VCol>

                    <VCol cols="12" md="6">
                      <VAutocomplete
                        class="font-weight-bold"
                        :items="size_company[$i18n.locale]"
                        v-model="fields.size"
                        :label="$t('CONTACTS.SIZE')"
                        variant="outlined"
                      />
                    </VCol>

                    <VCol cols="12">
                      <VTextarea
                        class="font-weight-bold"
                        v-model="fields.description"
                        :label="$t('CONTACTS.DESCRIPTION')"
                        rows="2"
                        variant="outlined"
                      />
                    </VCol>
                  </VRow>

                  <!-- reCAPTCHA + Honeypot/startedAt (mobile) -->
                  <div class="mt-4">
                    <div ref="rcMobile"></div>
                    <input type="hidden" v-model="hp" name="website_hp" />
                    <input type="hidden" :value="startedAt" name="started_at" />
                  </div>
                </VCardText>

                <VCardActions>
                  <VRow align="center" justify="space-around">
                    <VCol align="center" justify="space-around">
                      <VBtn
                        size="small"
                        :disabled="!meta.valid"
                        color="warning"
                        class="mr-5 ml-5 font-weight-bold"
                        type="submit"
                        variant="flat"
                      >
                        {{ $t('CONTACTS.SEND') }}
                      </VBtn>
                    </VCol>
                  </VRow>
                </VCardActions>
              </VCard>
            </fieldset>
          </Form>
        </VCol>

        <VCol cols="12" style="z-index: 2;">
          <div class="second-circle" style="margin: auto;">
            <div class="second-circle-txt text-white">Agende uma<br/>chamada connosco<br/>para tirar todas as<br/>suas dúvidas!</div>
            <div class="second-circle-img"><i class="mdi mdi-phone"></i></div>
          </div>
        </VCol>

        <VCol cols="12" style="z-index: 2;">
          <div class="circleContacts" style="margin: auto;">
            <div class="circleContacts-txt text-white">Envie-nos um email<br/> que responderemos<br/> o mais brevemente<br/> possível</div>
            <div class="circleContacts-img">@</div>
          </div>
        </VCol>

        <VCol cols="12" class="mt-n4" style="z-index: 2;">
          <div style="margin-left: 25%;">
            <div class="small-circle" style="margin: auto;"></div>
          </div>
        </VCol>

        <VCol cols="12" class="mt-n4" style="z-index: 2;">
          <div style="margin-left: 15%;">
            <div class="xsmall-circle" style="margin: auto;"></div>
          </div>
        </VCol>

        <VCol cols="12">
          <div class="text-center">
            <VCol cols="12" v-if="false">
              <VBtn size="x-large" class="font-weight-bold text-white" color="#E7C02C" style="width: 300px;" @click="emailSender()">
                {{ $t('CONTACTS.SEND_EMAIL') }}
              </VBtn>
            </VCol>

            <VCol cols="12">
              <VBtn size="x-large" class="font-weight-bold text-white" color="#E7C02C" style="width: 300px;" @click="clickHandler()">
                {{ $t('CONTACTS.SEND_MESSAGE') }}
              </VBtn>
            </VCol>
          </div>
        </VCol>

        <VCol cols="12">
          <div class="text-center">
            <VImg max-width="50px" style="margin: auto; display: block;" src="@/assets/icon_dream.png" />
          </div>
        </VCol>

        <VCol cols="12">
          <div class="text-center">
            <table style="margin: 0 auto;">
              <thead>
                <tr>
                  <td colspan="2">
                    <div class="text-h6 text-white font-weight-medium">
                      {{ $t('PRE_FOOTER.contacts') }}
                    </div>
                  </td>
                </tr>
              </thead>
              <tbody>
                <tr class="text-body font-weight-light text-white">
                  <td><VIcon class="text-white">mdi-email</VIcon></td>
                  <td>info@reportlake.com</td>
                </tr>
                <tr class="text-body font-weight-light text-white">
                  <td><VIcon class="text-white">mdi-clock</VIcon></td>
                  <td>{{ $t('PRE_FOOTER.work_week') }} - 9h {{ $t('PRE_FOOTER.to') }} 18h</td>
                </tr>
                <tr class="text-body font-weight-light text-white">
                  <td><VIcon class="text-white">mdi-phone</VIcon></td>
                  <td>+351 220 280 430</td>
                </tr>
              </tbody>
            </table>
          </div>
        </VCol>

        <VCol cols="12" class="my-6"></VCol>
      </VRow>
    </div>
  </VContainer>
</template>

<script>
import countries_pt from '@/assets/arrays/countries/pt.json'
import * as yup from 'yup'
import { Form, Field, ErrorMessage } from 'vee-validate'

export default {
  name: 'Contacts',
  components: { Form, Field, ErrorMessage },

  data() {
    return {
      rcIds: { desktop: null, mobile: null },
      loading: true,
      animated: false,
      countries: [],
      recaptchaSiteKey: process.env.VUE_APP_GOOGLE_CAPTCHA_KEY, // Vite: import.meta.env.VITE_RECAPTCHA_SITE_KEY
      startedAt: Math.floor(Date.now() / 1000),
      hp: '',

      fields: {
        name: null,
        company: null,
        numero: null,
        country: 'Portugal',
        size: null,
        email: null,
        title: null,
        description: null
      },

      size_company: {
        pt: ['< 5 empregados', '5 - 20 empregados', '20 - 50 empregados', '50 - 250 empregados', '> 250 empregados'],
        en: ['< 5 employees', '5 - 20 employees', '20 - 50 employees', '50 - 250 employees', '> 250 employees']
      },

      schema: yup.object({
        name: yup.string().required(),
        email: yup.string().email().required(),
        numero: yup.string().required()
      })
    }
  },

  mounted() {
    this.loading = false
    window.scrollTo(0, 0)
    this.countries = countries_pt

    // garantir script carregado (mantém o teu fallback)
    const ensureRender = () => {
      if (!window.grecaptcha || !window.grecaptcha.render) return
      window.grecaptcha.ready(() => {
        this.renderRecaptcha()
      })
    }

    if (!window.grecaptcha) {
      const s = document.createElement('script')
      s.src = 'https://www.google.com/recaptcha/api.js?hl=pt-PT'
      s.async = true
      s.defer = true
      s.onload = ensureRender
      document.head.appendChild(s)
    } else {
      ensureRender()
    }

    if (this.$route.name === 'contacts-qr') {
      const cookie = this.$cookies?.get?.('reportlake_website_cookie')
      const enter = !!(cookie && cookie.statistics !== false)
      if (enter && this.$gtag?.event) {
        this.$gtag.event('evento_1', {
          event_category: 'ContactosEvento1',
          event_label: 'ContactosEvento1',
          value: 'evento_1'
        })
      }
    }
  },

  methods: {
    renderRecaptcha() {
      if (!this.recaptchaSiteKey) {
        console.error('reCAPTCHA: Site Key em falta (VUE_APP_GOOGLE_CAPTCHA_KEY).')
        return
      }
      // Desktop
      if (this.$refs.rcDesktop && !this.rcIds.desktop) {
        this.rcIds.desktop = window.grecaptcha.render(this.$refs.rcDesktop, {
          sitekey: this.recaptchaSiteKey,
          theme: 'light',
          size: 'normal'
        })
      }
      // Mobile
      if (this.$refs.rcMobile && !this.rcIds.mobile) {
        this.rcIds.mobile = window.grecaptcha.render(this.$refs.rcMobile, {
          sitekey: this.recaptchaSiteKey
        })
      }
    },
    resetRecaptcha() {
      try {
        if (this.rcIds.desktop !== null) window.grecaptcha.reset(this.rcIds.desktop)
        if (this.rcIds.mobile  !== null) window.grecaptcha.reset(this.rcIds.mobile)
      } catch (e) {}
    },
    async enviarContacto() {
      try {
        this.loading = true

        // 1) Token reCAPTCHA v2 via widgetId
        let recaptchaToken = ''
        try {
          if (this.rcIds.desktop !== null) {
            recaptchaToken = window.grecaptcha.getResponse(this.rcIds.desktop) || ''
          }
          if (!recaptchaToken && this.rcIds.mobile !== null) {
            recaptchaToken = window.grecaptcha.getResponse(this.rcIds.mobile) || ''
          }
        } catch (e) {
          // se grecaptcha não estiver pronto
          console.error('grecaptcha.getResponse falhou', e)
        }
        if (!recaptchaToken) {
          throw new Error('Por favor confirme o reCAPTCHA.')
        }

        // 2) Payload para backend
        const payload = {
          name: this.fields.name,
          email: this.fields.email,
          subject: this.fields.title,
          message: this.fields.description,
          company: this.fields.company,
          numero: this.fields.numero,
          country: this.fields.country,
          size: this.fields.size,

          'g-recaptcha-response': recaptchaToken,
          website_hp: this.hp,
          started_at: this.startedAt
        }

        // 3) Enviar para o backend
        const url = process.env.VUE_APP_SEND_EMAIL // Vite: import.meta.env.VITE_SEND_EMAIL
        const res = await fetch(url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        })

        const json = await res.json()
        if (!res.ok || json?.success !== true) {
          throw new Error(json?.message || 'Falha ao enviar.')
        }

        // (Opcional) reset ao reCAPTCHA se ficares nesta página
        if (window.grecaptcha?.reset) {
          try { window.grecaptcha.reset() } catch (e) {}
        }

        // 4) Sucesso → navegar
        this.$router.push('/' + this.$i18n.locale + '/contacts/success')
      } catch (e) {
        this.$router.push('/' + this.$i18n.locale + '/contacts/success')
        return
      } finally {
        this.loading = false
      }
    },

    // Handlers antigos (mantidos)
    clickHandlerMobile() {
      this.animated = true
      setTimeout(() => (this.animated = false), 1000)
      this.$refs.formSender?.$el?.scrollIntoView?.({ behavior: 'smooth' })
    },
    emailSender() {
      window.location.href = 'mailto:info@reportlake.com?subject=&body='
    },
    clickHandler() {
      this.animated = true
      setTimeout(() => (this.animated = false), 1000)
    }
  }
}
</script>

<style>
/* (mantive o teu CSS; só troquei white--text -> text-white quando aplicável via classes Vuetify 3) */
*{margin:0;padding:0;box-sizing:border-box}
.black-blue{background-color:#111B2D}
.yellow-back{background-color:#E7C02C}

.semi-circle{
  aspect-ratio:1/1;
  background:#505c7b;
  border-radius:0 80% 80% 0;
  box-shadow: inset -3.5rem 1px 0 #7d869c, 3.5rem 1px 0 #bec2cd;
}

.semi-circle-mobile{
  --shadow-size:4vmin;
  aspect-ratio:1;
  background:#3D4A6D;
  border-radius:50%;
  box-shadow:var(--shadow-size) var(--shadow-size) 0 var(--shadow-size) #364363,
    calc(2 * var(--shadow-size)) calc(2 * var(--shadow-size)) 0 calc(2 * var(--shadow-size)) #26324C;
  width:90vmin; position:absolute; bottom:100%; right:100%;
  transform:translate(75%,75%); z-index:1;
}

.shake{animation:shake .82s cubic-bezier(.36,.07,.19,.97) both; transform:translate3d(0,0,0)}
@keyframes shake{
  10%,90%{transform:translate3d(-10px,0,0)}
  20%,80%{transform:translate3d(12px,0,0)}
  30%,50%,70%{transform:translate3d(-16px,0,0)}
  40%,60%{transform:translate3d(16px,0,0)}
}

.circleContacts{width:250px;height:250px;background:#9DA6BA;border-radius:50%;line-height:50px;position:relative}
.circleContacts::after{content:'';display:block;padding-bottom:100%}
.circleContacts-txt{position:absolute;line-height:20px;bottom:50%;font-weight:light;width:100%;text-align:center;font-size:15px}
.circleContacts-img{position:absolute;line-height:0;bottom:25%;width:100%;font-weight:900;color:#111B2D;font-size:100px;text-align:center}

.second-circle{width:200px;height:200px;background:#9DA6BA;border-radius:50%;line-height:50px;position:relative}
.second-circle::after{content:'';display:block;padding-bottom:100%}
.second-circle-txt{position:absolute;line-height:20px;bottom:50%;font-weight:light;width:100%;text-align:center;font-size:15px}
.second-circle-img{position:absolute;line-height:0;bottom:25%;width:100%;font-weight:900;color:#111B2D;font-size:100px;text-align:center}

.small-circle{width:75px;height:75px;background:#9DA6BA;border-radius:50%}
.xsmall-circle{width:42px;height:42px;background:#9DA6BA;border-radius:50%}

@media (min-width:850px){
  .circleContacts{width:350px;height:350px;background:#111B2D;border-radius:50%;line-height:50px;position:relative}
  .circleContacts::after{content:'';display:block;padding-bottom:100%}
  .circleContacts-txt{position:absolute;line-height:20px;bottom:50%;font-weight:400;width:100%;text-align:center;font-size:20px}
  .circleContacts-img{position:absolute;line-height:0;bottom:25%;width:100%;font-weight:900;color:#E7C02C;font-size:100px;text-align:center}

  .second-circle{width:275px;height:275px;background:#111B2D;border-radius:50%;line-height:50px;position:relative}
  .second-circle::after{content:'';display:block;padding-bottom:100%}
  .second-circle-txt{position:absolute;line-height:20px;bottom:50%;font-weight:300;width:100%;text-align:center;font-size:20px}
  .second-circle-img{position:absolute;line-height:0;bottom:25%;width:100%;font-weight:900;color:#E7C02C;font-size:100px;text-align:center}

  .small-circle{width:75px;height:75px;background:#111B2D;border-radius:50%}
  .xsmall-circle{width:42px;height:42px;background:#111B2D;border-radius:50%}
}
</style>
